export default __webpack_public_path__ + "static/media/select-group-create-anno.a988a5bd.png";